/* eslint-disable no-unused-vars */
/**
 * 存储编辑页编辑框中的数据
 */
import { defineStore } from "pinia";
import { reactive, ref } from 'vue';
import { CANVAS_SHAPE, DRAFT_DATA } from "@/utils/enum";

export const useTemplateStore = defineStore('templateData', () => {
  //模板数据
  const template = ref(null)
  //草稿id
  const draft_id = ref(null)
  //最新修改时间
  const last_updated_time = ref(0)
  //模板id
  const template_id = ref(null)
  //草稿名字
  const name = ref('')
  //数字人id
  const image_id = ref(null)
  //数字人图片
  const image_source_img = ref('')
  //数字人信息
  const image = ref('{}')
  //人脸数据位置
  const face_meta = ref(null)
  //画布形状
  const canvasShape = ref(CANVAS_SHAPE.VERTICAL)
  //画布宽度
  const width = ref(DRAFT_DATA.WIDTH)
  //画布高度
  const height = ref(DRAFT_DATA.HEIGHT)
  //画布比例
  const canvasRatio = ref(9 /16)
  //画布渲染JSON
  const parameter = ref('{}')
  //声音id
  const sound_id = ref(null)
  //声音数据
  const sound = ref({})
  //文本
  const text = ref('你好，我是简拼数字人')
  //封面图片
  const cover_img_url = ref('')
  //封面缩略图
  const small_cover_img_url = ref('')
  //是否重新生成封面
  const regenerate_cover = ref(0)
  //封面图片链接截取片段
  const cover_img_clip = ref('')
  //是否有使用数字人
  const use_image = ref(0)
  //是否使用定制的数字人制作
  const use_image_add = ref(false)
  //语速
  const speed = ref(1)
  //音量
  const volume_value = ref(100)
  //语调
  const pitch_offset_value = ref(0)
  //文案时长
  const text_duration = ref(0)
  //剩余制作时长
  const remaining_duration = ref(0)
  //剩余制作次数
  const remaining_times = ref(0)
  //文案试听音频链接
  const text_audio_url = ref('')
  //上传音频链接
  const audio_url = ref('')
  //上传音频名字
  const audio_name = ref('')
  //上传音频时长
  const audio_duration = ref(0)
  //旁白tab 1文案 2 音频
  const selected_tab = ref(1)
  //是否双字幕 0否 1是
  const double_subtitle = ref(0)
  //是否双字幕 0否 1是 不用上传
  const req_temp_double_subtitle = ref(0)
  //字幕语种
  const subtitle_language_type = ref('zh')
  //字幕记录ID
  const subtitle_record_id = ref(0)
  //字幕数据对象
  const subtitle_data = ref(null);
  //字幕数据对象
  const open_subtitle = ref(0);
  //字幕记录ID
  const subtitle_audio_url = ref(null)
  //字幕音频时长
  const subtitle_audio_duration = ref(0)
  // 形象底纹ID
  const background_id = ref(0)
  // 背景ID
  const canvas_background_id = ref(0)
  // 企业标识
  const logo_id = ref(0)
  // 字幕样式临时数据
  const subtitle_type = ref({})
  // 字幕样式临时数据主
  const subtitle_main_type = ref({})
  // 是否是否进入预览模式
  const temp_show_preview = ref(false)
  //背景音乐链接
  const bg_music_url = ref('')
  //背景音乐时长
  const bg_music_duration = ref(0)
  //设置模板数据
  const setTemplate = (value) => {
    if(value) {
      template_id.value = value.template_id || null
      template.value = value
      name.value = value.name || ''
      image_id.value = value.image_id || null
      cover_img_url.value = value.cover_img_url || ''
      small_cover_img_url.value = value.small_cover_img_url || ''
      regenerate_cover.value = value.regenerate_cover || 0
      image.value = JSON.stringify(value.image) || '{}'
      face_meta.value = value.face_meta || null
      parameter.value = JSON.stringify(value.parameter) || '{}'
      width.value = Number(value.width) || 0
      height.value = Number(value.height) || 0
      sound_id.value = value.sound_id || null
      sound.value = value.sound || {}
      text.value = value.text || '你好，我是简拼数字人'
      use_image.value = value.use_image || 0
      speed.value = value.speed || 1
      volume_value.value = value.volume_value != undefined ? value.volume_value : 100
      pitch_offset_value.value = value.pitch_offset_value || 0
      text_duration.value = value.text_duration || 0
      text_audio_url.value = value.text_audio_url || ''
      audio_url.value = value.sign_audio_url || ''
      audio_name.value = value.audio_name || ''
      subtitle_audio_url.value = value.subtitle_audio_url || null
      subtitle_language_type.value = value.subtitle_language_type || 'zh'
      audio_duration.value = value.audio_duration || 0
      open_subtitle.value = value.open_subtitle || 0
      double_subtitle.value = value.double_subtitle || 0
      subtitle_audio_duration.value = value.subtitle_audio_duration || 0
      subtitle_data.value = value.subtitle_data || null
      background_id.value = value.background_id || 0
      canvas_background_id.value = value.canvas_background_id || 0
      logo_id.value = value.logo_id || 0
      selected_tab.value = value.selected_tab || 1
      bg_music_url.value = value.bg_music_url || ''
      bg_music_duration.value = value.bg_music_duration || 0
    } else {
      clearInfo()
    }
  }

  //设置模板id
  const setTemplateId = (id) => {
    template_id.value = id
  }
  //设置草稿id
  const setDraftId = (id, time) => {
    draft_id.value = id
    last_updated_time.value = time
  }
  //设置名字
  const setName = (value) => {
    name.value = value
  }
  //设置数字人id
  const setImageId = (value, url) => {
    image_id.value = value
    image_source_img.value = url
    use_image.value = 1
  }

  //设置是否使用数字人
  const setUseImage = (value) => {
    use_image.value = value
  }
  //设置是否使用定制数字人制作
  const setUseImageAdd = (value) => {
    use_image_add.value = value
  }
  //设置数字人信息
  const setImage = (value) => {
    image.value = JSON.stringify(value)
  }
  //获取数字人信息
  const getImage = () => {
    return JSON.parse(image.value)
  }
  //设置人脸位置
  const setFaceMeta = (value) => {
    face_meta.value = value
  }
  //设置画布形状
  const setCanvasShape = (shape, _width = 0, _height = 0) => {
    canvasShape.value = shape
    switch (shape) {
      case CANVAS_SHAPE.VERTICAL:
        width.value = DRAFT_DATA.WIDTH
        height.value = DRAFT_DATA.HEIGHT
        break
      case CANVAS_SHAPE.HORIZONTAL:
        width.value = DRAFT_DATA.HEIGHT
        height.value = DRAFT_DATA.WIDTH
        break  
      case CANVAS_SHAPE.OTHER:
        width.value = _width
        height.value = _height
        const ratio = _width / _height 
        if(ratio === 9 / 16) {
          canvasShape.value = CANVAS_SHAPE.VERTICAL
        } else if(ratio === 16 / 9) {
          canvasShape.value = CANVAS_SHAPE.HORIZONTAL
        } else {
          canvasShape.value = CANVAS_SHAPE.OTHER
        }
        break
    }
    canvasRatio.value = width.value / height.value
  }
  //设置画布渲染JSON
  const setParameter = (param) => {
    parameter.value = JSON.stringify(param)
  }

  //获取画布渲染JSON
  const getParameter = () => {
    return JSON.parse(parameter.value)
  } 

  //设置画布objects信息
  const setObjects = (value) => {
   const _parameter = JSON.parse(parameter.value)
   _parameter.objects = value
   setParameter(_parameter)
  }
 
  //设置声音id
  const setSoundId = (id) => {
    sound_id.value = id
  }

  //设置格式化声音信息
  const setSound = (id, gender, small_cover_img_url, name, language_type_name, style_name, language_type) => {
    sound.value.id = id
    sound.value.gender = gender
    sound.value.small_cover_img_url = small_cover_img_url
    sound.value.name = name
    sound.value.style_name = style_name
    sound.value.language_type = language_type
    sound.value.language_type_name = language_type_name
  }

  //设置文本值
  const setText = (value) => {
    text.value = value
  }

  //设置封面
  const setCoverImg = (url) => {
    const endIndex = url.indexOf('?')
    if(endIndex !== -1) {
      cover_img_url.value = url.substring(0, endIndex)
    } else {
      cover_img_url.value = url
    }
  }

  //设置封面缩略图
  const setSmallCoverImg = (url) => {
    small_cover_img_url.value = url
  }

  //设置是否重新生成封面
  const setRegenerateCover = (value) => {
    regenerate_cover.value = value
  }

  //设置封面截取
  const setCoverImgClip = (url) => {
    if(!url) {
      cover_img_clip.value = ''
      return
    }
    const startIndex = url.indexOf('jianpin-dh/upload/')
    const endIndex = url.indexOf('?')
    let _url = ''
    if(endIndex === -1) {
      _url = url.substring(startIndex)
    } else {
      _url = url.substring(startIndex, endIndex)
    }
    cover_img_clip.value = _url
  }

  //设置声音调节信息
  const setControlsInfo = (_speed, _volume_value, _pitch_offset_value) => {
    speed.value = _speed
    volume_value.value = _volume_value
    pitch_offset_value.value = _pitch_offset_value
  }

  //设置试听文本信息
  const setTextAudioInfo = (_text_duration, _text_audio_url) => {
    text_duration.value = _text_duration
    text_audio_url.value = _text_audio_url
  }

  //设置文案时长
  const setTextDuration = (value) => {
    text_duration.value = value
  }

  //设置剩余时长
  const setRemainingDuration = (remaining_duration_value, remaining_times_value) => {
    remaining_duration.value = remaining_duration_value
    remaining_times.value = remaining_times_value
  }

  //设置上传音频链接
  const setAudioUrl = (value) => {
    audio_url.value = value
  }

  //设置上传音频名字
  const setAudioName = (value) => {
    audio_name.value = value
  }

  //上传音频时长
  const setAudioDuration = (value) => {
    audio_duration.value = value
  }

  //设置旁白tab
  const setSpeakTab = (value) => {
    selected_tab.value = value
  }

  //是否双字幕
  const setDoubleSubtitle = (value) => {
    double_subtitle.value = value
  }

  //是否双字幕
  const setReqDoubleSubtitle = (value) => {
    req_temp_double_subtitle.value = value
  }

  //是否双字幕
  const setSubtitleAudioUrl = (value) => {
    subtitle_audio_url.value = value
  }

  //字幕语种
  const setLanguageType = (value) => {
    subtitle_language_type.value = value
  }

  //字幕记录ID
  const setSubtitleRecordId = (value) => {
    subtitle_record_id.value = value
  }

  //字幕对象数据
  const setSubtitleData = (value) => {
    subtitle_data.value = value
  }

  //字幕音频时长
  const setSubtitleAudioDuration = (value) => {
    subtitle_audio_duration.value = value
  }

  //字幕是否显示
  const setOpenSubtitle = (value) => {
    open_subtitle.value = value
  }
  
  // 背景id
  const setCanvasBackgroundId = (value) => {
    canvas_background_id.value = value;
  }

  // 企业标识id
  const setLogoId = (value) => {
    logo_id.value = value;
  }

  // 形象底纹id
  const setBackgroundId = (value) => {
    background_id.value = value;
  }

  // 设置字幕样式
  const setSubtitleType = (value) => {
    subtitle_type.value = value;
  }

  // 设置主字幕样式
  const setMainSubtitleType = (value) => {
    subtitle_main_type.value = value;
  }

  // 是否是否进入预览模式
  const setTempShowPreview = (value) => {
    temp_show_preview.value = value;
  }

  //设置背景音乐信息
  const setBgMusicInfo = (_bg_music_url, _bg_music_duration) => {
    bg_music_url.value = _bg_music_url
    bg_music_duration.value = _bg_music_duration
  }
  //清空信息、还原
  const clearInfo = () => {
    draft_id.value = null
    last_updated_time.value = 0
    template_id.value = null
    template.value = null
    template_id.value = null
    name.value = ''
    image_id.value = null
    image_source_img.value = ''
    image.value = '{}'
    face_meta.value = null
    canvasShape.value = CANVAS_SHAPE.VERTICAL
    canvasRatio.value = 9 / 16
    parameter.value = '{}'
    width.value = 0
    height.value = 0
    sound_id.value = null
    sound.value = {}
    last_updated_time.value = 0
    text.value = ''
    use_image.value = 0
    use_image_add.value = false
    speed.value = 1
    volume_value.value = 100
    pitch_offset_value.value = 0
    text_duration.value = 0
    text_audio_url.value = ''
    audio_url.value = ''
    audio_name.value = ''
    selected_tab.value = 1
    double_subtitle.value = 0
    req_temp_double_subtitle.value = 0
    remaining_duration.value = 0
    remaining_times.value = 0
    subtitle_audio_url.value = null
    subtitle_language_type.value = 'zh'
    subtitle_data.value = null
    audio_duration.value = 0
    open_subtitle.value = 0
    subtitle_audio_duration.value = 0
    cover_img_url.value = ''
    small_cover_img_url.value = ''
    regenerate_cover.value = 0
    cover_img_clip.value = ''
    background_id.value = 0
    canvas_background_id.value = 0
    logo_id.value = 0
    bg_music_url.value = ''
    bg_music_duration.value = 0
  }

  
  //要传给后端的数据
  // const formData = reactive({
  //   draft_id: draft_id.value,
  //   last_updated_time: last_updated_time.value,
  //   name: name.value,
  //   cover_img: cover_img.value,
  //   image_id: image_id.value,
  //   template_id: template_id.value,
  //   width: width.value,
  //   height: height.value,
  //   // background_id: background_id.value,
  //   // logo_id: logo_id.value,
  //   // canvas_background_id: canvas_background_id.value,
  //   sound_id: sound_id.value,
  //   // emotion_id: emotion_id.value,
  //   speed: speed.value,
  //   volume_value: volume_value.value,
  //   pitch_offset_value: pitch_offset_value.value,
  //   text: text.value,
  //   text_audio_url: text_audio_url.value,
  //   text_duration: text_duration.value,
  //   audio_url: audio_url.value,
  //   audio_name: audio_name.value,
  //   audio_duration: audio_duration.value,
  //   // audio_volume_value: audio_volume_value.value,
  //   parameter: getParameter(),
  //   use_image: use_image.value,
  //   open_subtitle: open_subtitle.value,
  //   double_subtitle: double_subtitle.value,
  //   subtitle_language_type: subtitle_language_type.value,
  //   subtitle_record_id: subtitle_record_id.value,
  //   subtitle_audio_url: subtitle_audio_url.value,
  //   subtitle_audio_duration: subtitle_audio_duration.value,
  //   subtitle_data: subtitle_data.value,
  //   // bg_music_url: bg_music_url.value,
  //   // bg_music_volume_value: bg_music_volume_value.value,
  // })


  return { 
    template, template_id, image_id, image_source_img, image, cover_img_url, small_cover_img_url, regenerate_cover, face_meta, draft_id, canvasShape, parameter, width, height, sound_id, sound, last_updated_time, name, text, cover_img_clip, use_image, use_image_add, speed, volume_value, pitch_offset_value, text_duration, text_audio_url, audio_url, audio_name, canvasRatio, double_subtitle, subtitle_language_type, selected_tab, subtitle_record_id, subtitle_data, open_subtitle, subtitle_audio_url, remaining_duration, remaining_times, req_temp_double_subtitle, audio_duration, subtitle_audio_duration,background_id,logo_id,canvas_background_id, subtitle_type,subtitle_main_type, temp_show_preview, bg_music_url, bg_music_duration,
    setTemplate, setTemplateId, setDraftId, setCanvasShape, setParameter, getParameter, setSoundId, setName, setText, setCoverImg, setSmallCoverImg, setRegenerateCover, setImageId, setImage, getImage, setFaceMeta, setObjects, setControlsInfo, setTextAudioInfo, setAudioUrl, setAudioName, setDoubleSubtitle, setLanguageType, setSpeakTab, setSubtitleRecordId, setSubtitleData, setOpenSubtitle, setSubtitleAudioUrl, setRemainingDuration, setTextDuration, setReqDoubleSubtitle, setAudioDuration, setSubtitleAudioDuration, setCoverImgClip,setCanvasBackgroundId,setBackgroundId,setLogoId,setSubtitleType,setMainSubtitleType, setUseImage, setUseImageAdd, setTempShowPreview, setBgMusicInfo, setSound,
  }
})
